import { Box, Button, Heading, Page, TextButton } from '@zillow/constellation-10';
import { IconPlusCircleFilled } from '@zillow/constellation-icons';

import { AppSelectors } from '../../../selectors';
import { useSelector } from '../../../selectors/useSelector';
import accessUtils from '../../../utils/accessUtils';
import AddPropertyModalCSEvents from '../../../model/ClickstreamEvent/AddPropertyModalCSEvents';

type Props = {
  handleAddPropertyClick: () => void;
  handleAddFeedListingsClick: () => void;
};

const PageHeading = ({ handleAddPropertyClick, handleAddFeedListingsClick }: Props) => {
  const user = useSelector((state) => state.user);
  const isScreenMobile = useSelector((state) => AppSelectors.makeIsScreenMobile(state));

  const showAddPropertyButton = user.features.canAddListing;
  const canAccessAddFeedListingsModal = accessUtils.canAccessAddFeedListingsModal({ user });
  const showButtonsNextRow = isScreenMobile && showAddPropertyButton && canAccessAddFeedListingsModal;

  const pageTitle = 'Properties';

  const renderAddButtons = () => (
    <Box css={{ display: 'flex' }}>
      {showAddPropertyButton && (
        <Button
          tone="brand"
          emphasis="outlined"
          onClick={handleAddPropertyClick}
          data-testid="AddPropertyButton"
          data-eventid={AddPropertyModalCSEvents.Open.data_event_id}
          data-eventdescription="View add property modal"
          icon={<IconPlusCircleFilled />}
          iconPosition="end"
        >
          Add a property
        </Button>
      )}
      {canAccessAddFeedListingsModal && (
        <Box css={{ paddingLeft: '600' }}>
          <TextButton
            textStyle="body-bold"
            tone="brand"
            onClick={handleAddFeedListingsClick}
            data-eventid={AddPropertyModalCSEvents.AddFeedClick.data_event_id}
            data-eventdescription="View add feed modal"
            icon={<IconPlusCircleFilled />}
          >
            Add feed
          </TextButton>
        </Box>
      )}
    </Box>
  );

  return (
    <Page.Content css={{ marginBottom: '400' }}>
      {!showButtonsNextRow && (
        <Box css={{ display: 'flex', alignItems: 'center' }}>
          <Box css={{ flex: '1' }}>
            <Heading level={1} fontFamily="heading-alt" textStyle="heading-md">
              {pageTitle}
            </Heading>
          </Box>
          <Box css={{ paddingLeft: '400' }}>{renderAddButtons()}</Box>
        </Box>
      )}
      {showButtonsNextRow && (
        <Box>
          <Heading level={1} fontFamily="heading-alt" textStyle="heading-md">
            {pageTitle}
          </Heading>
          <Box css={{ paddingTop: '400' }}>{renderAddButtons()}</Box>
        </Box>
      )}
    </Page.Content>
  );
};

export default PageHeading;
